/**
 * WOM Configuration — SoTrue
 * API: https://api.thewordofmouth.in/api/reviews/sotrue/{product-handle}
 */

const DEFAULT_PRODUCT_HANDLE = "3-in-1-illuminating-strobe-cream-combo-pack-of-3";

function getProductTitle() {
  const titles = [];
  const selectors = [
    'h1[itemprop="name"]',
    'h1.product-title',
    '.product__title h1',
    '.product-single__title',
    "h1",
  ];
  for (const selector of selectors) {
    const h1 = document.querySelector(selector);
    if (h1 && h1.textContent) {
      const t = h1.textContent
        .trim()
        .replace(/\s+/g, " ")
        .replace(/\n/g, "")
        .replace(/\r/g, "");
      titles.push(t);
      break;
    }
  }
  const pageTitle = document.title;
  if (pageTitle) {
    let clean = pageTitle;
    if (clean.includes(" | ")) clean = clean.split(" | ")[0];
    else if (clean.includes(" – ")) clean = clean.split(" – ")[0];
    else if (clean.includes(" - ")) clean = clean.split(" - ")[0];
    titles.push(clean.trim().replace(/\s+/g, " "));
  }
  if (
    typeof window.ShopifyAnalytics !== "undefined" &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.name
  ) {
    titles.push(
      String(window.ShopifyAnalytics.meta.product.name).trim()
    );
  }
  const og = document.querySelector('meta[property="og:title"]');
  if (og && og.content) titles.push(og.content.trim());
  if (titles.length === 0) return null;
  return titles.reduce((a, b) => (b.length > a.length ? b : a));
}

/**
 * Product segment for the reviews API: Shopify product handle (matches WOM product slug).
 * On collection (and other non-PDP) pages we return null so the reviews API is not called
 * with a wrong handle from ShopifyAnalytics (e.g. first product in the grid).
 */
function getProductHandle() {
  const path = window.location.pathname || "";
  const fromUrl = path.match(/\/products\/([^/?]+)/);
  if (fromUrl && fromUrl[1]) return fromUrl[1];

  const body = typeof document !== "undefined" && document.body;
  if (!body || !body.classList.contains("template-product")) {
    return null;
  }

  if (
    typeof window.ShopifyAnalytics !== "undefined" &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.handle
  ) {
    return window.ShopifyAnalytics.meta.product.handle;
  }
  const metaUrl = document.querySelector('meta[property="og:url"]');
  if (metaUrl && metaUrl.content) {
    const mm = metaUrl.content.match(/\/products\/([^/?]+)/);
    if (mm && mm[1]) return mm[1];
  }
  return DEFAULT_PRODUCT_HANDLE;
}

const vesselsWOMConfig = {
  name: "SoTrue",
  apiBaseUrl: "https://api.thewordofmouth.in",
  companyId: "sotrue",

  disableReviewsApi: false,
  disableInstagramApi: true,

  getProductTitle: getProductTitle,
  getProductHandle: getProductHandle,

  get reviewsApiUrl() {
    if (this.disableReviewsApi) return null;
    const handle = this.getProductHandle ? this.getProductHandle() : null;
    if (!handle) return null;
    return `${this.apiBaseUrl}/api/reviews/${this.companyId}/${encodeURIComponent(handle)}?offset=0&limit=100`;
  },

  get detailedReviewsApiUrl() {
    if (this.disableReviewsApi) return null;
    const handle = this.getProductHandle ? this.getProductHandle() : null;
    if (!handle) return null;
    return `${this.apiBaseUrl}/api/reviews/${this.companyId}/${encodeURIComponent(handle)}?offset=0&limit=100`;
  },

  useLocalData: false,
  localDataUrl: "/assets/wom-product-data.json",
  debug: false,

  colors: {
    primary: "#1a1a1a",
    accent: "#231f20",
    background: "#ffffff",
    text: "#374151",
    textLight: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    starColor: "#fbcd07",
  },

  spacing: {
    cardRadius: "12px",
    cardPadding: "20px",
    gap: "16px",
  },

  components: {
    socialProof: false,
    liveUsers: false,
    ratingBreakdown: true,
    reviews: true,
  },

  useCompanyWideData: false,

  settings: {
    liveUpdates: true,
    showVerifiedBadge: true,
    reviewsPerPage: 5,
  },

  onWriteReview: function () {},
  onLoadMore: function () {},
};

if (typeof module !== "undefined" && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  window.vesselsWOMConfig = vesselsWOMConfig;
  window.clientWOMConfig = vesselsWOMConfig;
}
